import Avatar from '@mui/material/Avatar';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { makeObservable, observable } from 'mobx';
import MeioJulgamentoProcesso from '../../dominio/MeioJulgamentoProcesso';
import { Filtro } from './Filtro';

export default class FiltroTipoJulgamento extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Meio de julgamento (tipo de julgamento)';
    }

    getIconeFiltroRapido(cor) {
        return (
            <Avatar
                sx={{
                    width: '26px',
                    height: '26px',
                    fontWeight: '600',
                    fontSize: '0.98rem',
                    backgroundColor: cor
                }}
            >
                J
            </Avatar>
        );
    }

    opcoesFiltro = FiltroTipoJulgamento.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo,
                cor: MEIO_JULGAMENTO_PROCESSO.VIRTUAL.cor,
                icone: MeioJulgamentoProcesso.getIcone(MEIO_JULGAMENTO_PROCESSO.VIRTUAL.id)
            },
            {
                valor: MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo,
                cor: MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.cor,
                icone: MeioJulgamentoProcesso.getIcone(MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.id)
            },
            {
                valor: MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo,
                cor: MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.cor,
                icone: MeioJulgamentoProcesso.getIcone(MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.id)
            },
            {
                valor: MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.codigo,
                cor: MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.cor,
                icone: MeioJulgamentoProcesso.getIcone(MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.id)
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        if (
            registro?.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo &&
            registro?.remessaJulgamento?.tipo?.id
        ) {
            return MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.codigo;
        }

        return registro?.tipoJulgamento;
    }

    getDescricao(valor) {
        if (typeof valor === 'undefined') {
            return '';
        }

        return MeioJulgamentoProcesso.getDescricaoByCodigo(valor);
    }
}
